/* BAYRUE — autoplay for the reviews rail.

   The rail is a native scroll-snap container, so this does not manage slide state or
   transforms; it just scrolls it. That keeps the carousel working exactly as well with
   this script blocked or failed as without it - dragging and swiping are the browser's.

   Advances by one full page (the visible width) rather than one card, so a desktop rail
   showing three does not creep sideways one review at a time. */
(function () {
  'use strict';

  var reduceMotion =
    window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function start(root) {
    if (root.dataset.bayrueRvBound === '1') return;
    root.dataset.bayrueRvBound = '1';

    var rail = root.querySelector('.bayrue-reviews__list');
    if (!rail) return;

    var seconds = parseFloat(root.getAttribute('data-autoplay-seconds')) || 6;
    if (root.getAttribute('data-autoplay') !== 'true') return;

    // Someone who has asked their OS for less motion should not get a moving carousel.
    // They can still scroll it themselves.
    if (reduceMotion) return;

    var timer = null;
    var paused = false;

    function pageWidth() {
      return rail.clientWidth;
    }

    function atEnd() {
      // 2px of tolerance: sub-pixel widths mean scrollLeft rarely lands exactly.
      return rail.scrollLeft + rail.clientWidth >= rail.scrollWidth - 2;
    }

    function advance() {
      if (paused || document.hidden) return;
      if (rail.scrollWidth <= rail.clientWidth + 2) return; // nothing to scroll
      var target = atEnd() ? 0 : rail.scrollLeft + pageWidth();
      rail.scrollTo({ left: target, behavior: 'smooth' });
    }

    function run() {
      stop();
      timer = window.setInterval(advance, seconds * 1000);
    }

    function stop() {
      if (timer) window.clearInterval(timer);
      timer = null;
    }

    // Reading a review is the one moment the carousel must not move. Pointer, keyboard
    // focus and touch all count as reading.
    ['pointerenter', 'focusin', 'touchstart'].forEach(function (evt) {
      root.addEventListener(evt, function () { paused = true; }, { passive: true });
    });
    ['pointerleave', 'focusout'].forEach(function (evt) {
      root.addEventListener(evt, function () { paused = false; }, { passive: true });
    });

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) stop();
      else run();
    });

    run();
  }

  function init() {
    document.querySelectorAll('.bayrue-reviews').forEach(start);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // The theme editor rebuilds a section's DOM on every setting change.
  document.addEventListener('shopify:section:load', init);
})();
